<template>
    <div class="resident-warpper">
        <div class="bg-white">
            <div class="flex align-center justify-between">
                <div class="flex align-center justify-between">
<!--                    <div class="flex align-center margin-right-sm ">-->
<!--                        <span>图片名称：</span>-->
<!--                        <el-input v-model="keyword" placeholder="请输入图片名称" class="flex-sub"></el-input>-->
<!--                    </div>-->
<!--                    <el-button type="primary" @click="hanldSearch">搜索</el-button>-->
                </div>
                <div>
                    <router-link to="/home/flove_image/0">
                        <el-button type="primary">添加图片</el-button>
                    </router-link>
                </div>
            </div>

            <div class="flex align-center justify-between margin-tb-sm">
                <div>
                    共{{ total }}条数据
                </div>
            </div>

            <el-table
                :data="list"
                header-row-class-name="table-header"
                row-class-name="table-row"
                alig="center"
                border
                style="width: 100%">
                <el-table-column width="70" type="index" align="center" label="序号"></el-table-column>
                <el-table-column label="图片名称" prop="name"></el-table-column>
                <el-table-column label="缩略图" prop="image">
                    <template slot-scope="scope">
                      <el-image class="image" :src="scope.row.image"></el-image>
                    </template>
                </el-table-column>
                <el-table-column label="添加时间" prop="create_time" width="180"></el-table-column>
                <el-table-column label="操作" width="300">
                    <template slot-scope="scope">
                        <div class="table-operate">
                            <el-button
                                size="small"
                                type="primary"
                                @click="editItem(scope.row.id)">编辑
                            </el-button>
                            <el-button
                                size="small"
                                type="danger"
                                @click="delItem(scope.row.id)">删除
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
<!--            <el-pagination-->
<!--                v-if="list.length > 0"-->
<!--                class="page-all"-->
<!--                background-->
<!--                @current-change="getList"-->
<!--                :current-page.sync="page"-->
<!--                :page-size="limit"-->
<!--                layout="prev, pager, next, jumper"-->
<!--                :total="total">-->
<!--            </el-pagination>-->
        </div>
    </div>
</template>

<script>

import {delLoveBanner, qqBannerList} from "@/api/tongji";

export default {
    name: "flove_image",
    data() {
        return {
            keyword: '',
            page: 1,
            limit: 10,
            total: 0,
            list: [],
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    created() {
        this.$emit("setIndex", this.$route.path, "双暖为老 / 图片管理", false);
        this.getList()
    },
    components: {},
    methods: {
        //  搜索
        hanldSearch() {
            this.page = 1
            this.getList()
        },
        //  获取列表
        async getList() {
            const res = await qqBannerList()
            this.list = res.data
            this.total = res.total_number
        },
        //  添加修改视频
        editItem(id) {
            this.$router.push('/home/flove_image/' + id)
        },

        //  删除视频
        delItem(id) {
            this.$confirm('您确定要删除该图片吗？', "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                cancelButtonClass: "msg-btn",
                confirmButtonClass: "msg-btn",
                center: true
            }).then(() => {
                this.sureDel(id);
            });
        },
        async sureDel(id) {
            let _state = await delLoveBanner(id);
            if (this.list.length === 1 && this.page > 1) {
                this.page--;
            }
            this.getList();
            this.$message.success(_state.info);
        },
    },
    filters: {},
    watch: {},
}
</script>

<style scoped lang="scss">

.image {
    width: 200px;
    height: 80px;
}
</style>
